"use client";

import { memo } from "react";
import { useController, useFormContext } from "react-hook-form";
import { HmcToggle } from "@adi-ctx/harmonic-core-components-react";

type FormToggleProps = {
	readonly [key: string]: any;
	readonly label: string;
	readonly field: string;
};

/**
 * Toggle form field
 * @constructor
 */
function FormToggle(props: FormToggleProps) {
	const { control } = useFormContext();
	const { field } = useController({
		control,
		name: props.field,
	});

	return (
		<HmcToggle
			name={props.field}
			isChecked={field.value}
			data-testid="cms-form-toggle"
			onChanged={({
				detail: { checked },
			}: {
				detail: { checked: boolean };
			}) => {
				field.onChange(checked); // send data to react hook form
			}}
			{...props}
			label={props.label}
		/>
	);
}

export default memo(FormToggle);
